<template>
  <div id="equipment">
    <h2>Equipos</h2>
    <div class="list-grid">
      <div v-for="item in neveras" :key="item.caption" class="grid-item">
        <div class="grid-item-image">
          <img :src="item.src" alt="Refrigerator" />
        </div>
        <div class="grid-item-caption">{{ item.caption }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import nevera1 from '@/assets/nevera_1_1.png'
import nevera2 from '@/assets/nevera_2_2.png'
import nevera3 from '@/assets/nevera_3_3.png'
import nevera4 from '@/assets/nevera_4_4.png'

export default {
  name: 'EquipmentSection',
  data() {
    return {
      neveras: [
        { src: nevera1, caption: 'Nevera 1' },
        { src: nevera2, caption: 'Nevera 2' },
        { src: nevera3, caption: 'Nevera 3' },
        { src: nevera4, caption: 'Nevera 4' }
      ]
    }
  }
}
</script>
